import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import { required as Required } from "src/shared/forms/validations/Required";
import TextValidation from "src/shared/forms/validations/TextValidation";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface IMerchantGroupNameInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="merchant_groups.name" />,
  validationDisabled = false,
  ...rest
}: IMerchantGroupNameInputProps) => {
  const validations: ValidationHandler[] = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return [
      Required,
      Length(3, 64),
      TextValidation(<FormattedMessage id="form.validations.name.invalid" />),
    ];
  }, [validationDisabled]);
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
